import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";

import { getAppConfigSetting } from "../utils/getAppConfigSetting";
import { CORRESPONDENT_API } from "./constants";
import queryKeys from "./queryKeys";

export interface CorrespondentSummaryData {
  code: string;
}

export function useGetCorrespondentSummary(accountNumber: string) {
  const getCorrespondentSummaryApi = `${getAppConfigSetting(
    "apiUrl"
  )}${CORRESPONDENT_API}`;

  const correspondentSummaryUrl = (accountNumber: string) =>
    `${getCorrespondentSummaryApi}/?account=${accountNumber}`;
  const getCorrespondentSummary = async () => {
    const { data } = await axios.get(correspondentSummaryUrl(accountNumber), {
      withCredentials: true,
    });
    return data;
  };
  return useQuery<CorrespondentSummaryData, AxiosError>(
    [queryKeys.correspondentSummary, accountNumber],
    getCorrespondentSummary,
    {
      enabled: false,
    }
  );
}
